import { PayloadTask } from "routes/regime/components/payload-task"
import { ContentOverrideField } from "routes/regime/components/content-override-field"

// Replaces the task title editing area for collaboration clients (share-link content overrides): the
// master task title becomes directly editable inline (writing to the payload task `titleOverride`) in
// place of the read-only display. Uses the compact single-line variant of ContentOverrideField — a title
// is a short heading, not a rich-text body. The override is applied at render in api/library/extend-schedule.mjs.
export function InlineTaskTitleOverride() {
    return (
        <PayloadTask>
            <ContentOverrideField field="titleOverride" sourcePath="title" singleLine />
        </PayloadTask>
    )
}
